import PropTypes from "prop-types";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import useCoinDetails from "../../hooks/useCoinDetails";

function TaxBreakdown({ taxes }) {
  const { currentSymbolCoin } = useCoinDetails();

  return (
    <Accordion
      square
      sx={{
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
      }}
    >
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
        sx={{
          "paddingX": 0,
          "borderBottom": "1px solid rgba(0, 0, 0, 0.1)",
          "minHeight": "48px",
          "&.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: "12px 0",
          },
        }}
      >
        <Typography>Desglose de Impuestos</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {taxes.map(tax => (
          <Typography>
            <strong>{tax.description}:</strong>{" "}
            {`${currentSymbolCoin}${tax.value}`}
          </Typography>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
TaxBreakdown.propTypes = {
  taxes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ),
};

TaxBreakdown.defaultProps = {
  taxes: [],
};
export default TaxBreakdown;
